import { Avatar, Grid } from "@mui/material";
import BasicImage from "pages/MyPage/component/BasicImage";
import { ListItemText } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";

import AdviceTimelinePageStore from "pages/AdviceTimelinePage/store/AdviceTimelinePageStore";
import { observer } from "mobx-react";

interface Props {
  pageStore: AdviceTimelinePageStore;
}

function TopInfoArea({ pageStore }: Props) {
  return (
    <Grid container alignItems={'center'} style={{ marginTop: '40px' }}>
      <Grid style={{ marginLeft: '20px' }}>
        {pageStore.employee?.userData?.profile ? (
          <BasicImage
            src={pageStore.employee.userData?.profile}
            style={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              objectFit: 'cover',
              overflow: 'hidden',
            }}
          />
        ) : (
          <Avatar style={{ width: 60, height: 60 }}>
            <ImageIcon
              sx={{
                borderRadius: '50%',
                objectFit: 'cover',
                overflow: 'hidden',
              }}
            />
          </Avatar>
        )}
      </Grid>
      <ListItemText
        primary={
          <span
            style={{
              fontFamily: 'Pretendard',
              fontStyle: 'normal',
              fontWeight: 600,
              fontSize: '16px',
              lineHeight: '16px',
              color: '#000000',
            }}
          >
            {pageStore.employee?.userData.deptName}
          </span>
        }
        secondary={
          <span
            style={{
              fontFamily: 'Pretendard',
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '14px',
              color: '#212121',
            }}
          >
            {pageStore.employee?.names?.fullname}
            <span
              style={{
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '12px',
                color: '#6C6B6F',
                marginLeft: '4px',
              }}
            >
              {pageStore.employee?.userData.jobTitle}
            </span>
          </span>
        }
        style={{
          margin: 0,
          marginLeft: '16px',
        }}
      />
    </Grid>
  );
}

export default observer(TopInfoArea);
